// extracted by mini-css-extract-plugin
module.exports = {"VendorProfileTradingAddress__tooltip":"VendorProfileTradingAddress_VendorProfileTradingAddress__tooltip__2XQpg"};